module.exports = __webpack_public_path__ + "assets/img/end.ce3af201.png";